import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirects to the security section of the account page. */
export const Route = createFileRoute('/_app/_platform/account/security')({
    beforeLoad: ({ search }) => {
        throw redirect({ to: '/account', search, hash: 'security', replace: true });
    },
});
